function StaffTypesController(){
	this.className	= "StaffTypesController";
	this.glob		= "/**";
	this.debug		= false;
};
StaffTypesController.inheritsFrom( StandardController );
StaffTypesController.prototype.setupPage = function(){
	console.log("StaffTypesController: setupPage called");
};
StaffTypesController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
};

/**
 * Config the staff types animation for the informed revealer.
 * (This function is called in revealerController.js, the first time
 * the revealer is opened)
 */
StaffTypesController.prototype.configStaffTypes = function(revealer){

  const staffTypes = revealer.find('.staff-type');

  for (let staffTypeIndex=0; staffTypeIndex<staffTypes.length; staffTypeIndex++) {
    
    // Identify the current staff type and sub-elements.
    const staffType = staffTypes[staffTypeIndex];
    const shortTitle = staffType.querySelector('.short-title');
    const title = staffType.querySelector('.title');
    
    // *** Short Title
    // Update the shortTitle width to force a rounded value.
    // (this is necessary to make sure it equals the value applied to the title element)
    shortTitle.style.width = `${shortTitle.offsetWidth}px`;

    // *** Title
    // Store the current width to be used when the element is expanded.
    title.dataset.width = title.offsetWidth;
    // Resize and position  the title according to the short title.
    title.style.width = `${shortTitle.offsetWidth}px`;
    title.style.marginLeft = `-${shortTitle.offsetWidth}px`;

    // To prevent an undesired initial animation, the transition is not site by default
    // and will only be defined after a small delay.
    setTimeout(() => {
      staffType.classList.add('ready');
    }, 300);
    
    // Change elements opacity and width on "mouseenter"
    staffType.addEventListener('mouseenter', (e) => {
      shortTitle.style.opacity = 0;
      title.style.opacity = 1;
      title.style.width = `${title.dataset.width}px`;
    })
    
    // Change elements opacity and width on "mouseleave"
    staffType.addEventListener('mouseleave', (e) => {
      shortTitle.style.opacity = 1;
      title.style.opacity = 0;
      title.style.width = `${shortTitle.offsetWidth}px`;    
    })
  }

};